/* INTEGY V223 — desktop search priority + quickshop/collection polish hooks — 10JUN2026 */
(function () {
  'use strict';
  if (window.INTEGY_V223_DESKTOP_POLISH_LOADED) return;
  window.INTEGY_V223_DESKTOP_POLISH_LOADED = true;

  function mq(q) { try { return window.matchMedia && window.matchMedia(q).matches; } catch (e) { return false; } }
  var desktop = mq('(min-width: 861px)');
  document.documentElement.classList.add('integy-v223-desktop-polish');

  function qsa(sel, root) { try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; } }
  function qs(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }

  function fixCollectionMasthead() {
    if (!desktop || !document.body || !document.body.classList.contains('template-collection')) return;
    qsa('.productgrid--masthead,.collection--masthead,.collection-header').forEach(function (box) {
      box.classList.add('integy-v223-collection-masthead');
      box.style.setProperty('overflow', 'visible', 'important');
      qsa('.collection--description,[data-collection-description],.rte', box).forEach(function (desc) {
        desc.classList.add('integy-v223-collection-description');
        desc.style.setProperty('max-height', 'none', 'important');
        desc.style.setProperty('overflow', 'visible', 'important');
        desc.style.setProperty('overflow-x', 'visible', 'important');
        desc.style.setProperty('white-space', 'normal', 'important');
      });
    });
  }

  function markQuickshop() {
    if (!desktop) return;
    qsa('.modal--quickshop-full, [data-modal-container].modal--quickshop-full').forEach(function (m) {
      m.classList.add('integy-v223-quickshop-polished');
    });
  }

  function showEarlySearchStatus(input) {
    if (!desktop || !input || !input.value || input.value.trim().length < 2) return;
    var form = input.closest && input.closest('form[action*="/search"],form[role="search"],.integy-collections-hub__search,.live-search-form');
    if (!form) return;
    var panel = document.getElementById('integy-v204-one-search-panel');
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'integy-v204-one-search-panel';
      panel.className = 'integy-v204-one-search-panel';
      panel.setAttribute('role','listbox');
      panel.setAttribute('aria-label','Search suggestions');
      document.body.appendChild(panel);
    }
    if (!panel.innerHTML || panel.innerHTML.indexOf('Searching products') === -1) {
      panel.innerHTML = '<div class="integy-v223-searching">Searching products, collections, and thumbnails…</div>';
    }
    var r = input.getBoundingClientRect();
    panel.style.position = 'fixed';
    panel.style.left = Math.max(8, r.left) + 'px';
    panel.style.top = Math.round(r.bottom + 6) + 'px';
    panel.style.width = Math.max(360, r.width) + 'px';
    panel.style.maxHeight = 'min(70vh, 640px)';
    panel.style.zIndex = '2147483640';
  }

  function primeSearchInput(input) {
    if (!desktop || !input || !input.matches) return;
    if (!input.matches('input[type="search"],input[name="q"],input[name="search"],input[name="query"]')) return;
    var form = input.closest && input.closest('form[action*="/search"],form[role="search"],.integy-collections-hub__search,.live-search-form');
    if (!form) return;
    showEarlySearchStatus(input);
  }

  document.addEventListener('input', function (e) { primeSearchInput(e.target); }, true);
  document.addEventListener('focusin', function (e) { primeSearchInput(e.target); }, true);

  function boot() {
    fixCollectionMasthead();
    markQuickshop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  window.addEventListener('pageshow', function () { setTimeout(boot, 0); }, { passive: true });
  setInterval(markQuickshop, 700);
})();
